import apiClient from '@/services/axios'

const getAll = async (params) => {
  try {
    const res = await apiClient.get('/city', { params })
    return res.data
  } catch (e) {
    console.log('error when getting city data with error: ' + e)
    return []
  }
}

const getProvinces = async () => {
  try {
    const res = await apiClient.get('/city/provinces')
    return res.data
  } catch (e) {
    console.log('error when getting province data with error: ' + e)
    return []
  }
}

export {
  getAll,
  getProvinces,
}
